<template>
  <div class="w-100">
    <a
      href="#"
      @click="returnToOverview"
    > zurück zur Benutzerverwaltung </a>
    <br>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-else-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <template v-else>
      <div class="form-group mb-4">
        <b-container>
          <b-row class="">
            <label class="pl-0 mt-3 col-3 defaultLabel"> Benutzername </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="usernameInput"
                v-model="userObject.email"
                disabled
              />
            </div>
          </b-row>
          <b-row class="">
            <label class="pl-0 mt-4 col-3 defaultLabel"> Vorname </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="firstNameInput"
                v-model="userObject.firstName"
              />
            </div>
          </b-row>
          <b-row class="">
            <label class="pl-0 mt-4 col-3 defaultLabel"> Nachname </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="surNameInput"
                v-model="userObject.lastName"
              />
            </div>
          </b-row>
          <b-row class="mt-4">
            <label class="pl-0 col-3 defaultLabel"> Rollen </label>
            <div class="col-9 pl-0 checkboxControl">
              <div
                v-for="role in roles"
                :key="role"
              >
                <label>
                  <input
                    v-model="userObject.roles"
                    :value="role"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text">{{ role }}</span>
                </label>
              </div>
            </div>
          </b-row>
          <b-row class="mt-4 pt-1">
            <label class="pl-0 col-3 defaultLabel"> CMS </label>
            <div class="col-9 pl-0 checkboxControl">
              <div
                v-for="role in cmsRoles"
                :key="role"
              >
                <label>
                  <input
                    v-model="userObject.roles"
                    :value="role"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text">{{ role }}</span>
                </label>
              </div>
            </div>
          </b-row>
          <b-row class="mt-4">
            <label class="pl-0 col-3 defaultLabel"> gesperrt </label>
            <div class="col-9 pl-0">
              <div class="form-check pl-0">
                <label>
                  <input
                    v-model="userObject.locked"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
              </div>
            </div>
          </b-row>
          <button
            class="btn btn-danger smallActionButton float-right mr-4"
            placement="bottom"
            title="Löschen"
            @click="deleteUser"
          >
            <i class="fas fa-trash" />
          </button>
          <b-row class="mt-4">
            <button
              class="btn btn-success"
              title="Bearbeiten"
              @click="SaveUser"
            >
              Speichern
            </button>
            <button
              class="btn btn-danger ml-2"
              title="Bearbeiten"
              @click="returnToOverview"
            >
              Abbrechen
            </button>
          </b-row>
        </b-container>
      </div>
      <hr>
      <PasswordReset :user-id="userId" />
    </template>
  </div>
</template>

<script>
import PasswordReset from "@/components/UserManagement/PasswordReset.vue";
import {
  DeleteUser,
  GetRoles,
  GetUser,
  UpdateUser,
} from "@/services/user.service.js";

export default {
  components: {
    PasswordReset,
  },
  data() {
    return {
      userObject: null,
      userId: null,
      errorObject: null,
      isLoading: false,
      roles: [],
      cmsRoles: [],
      rolesDescriptions: {
        VertragsmanagementVetragsDetails: "Vertragsdetails bearbeiten",
        VertragsmanagementUniaVertragsverantworlich:
          "Unia-Vertragsverantwortlich",
        VertragsmanagementAdministration: "Rollen verwalten, Auditlog",
        VertragsmanagementVerwaltung: "Editieren von Verträgen",
        VertragsmanagementEinsicht: "Einsehen von Verträgen",
        KonfigurationContentmanager: "Kontakte usw. verwalten",
        KlauselauspraegungAdministration:
          "Konfigurieren von Klauselausprägungen",
        AllgemeinerFeiertagskalenderAdministration:
          "Konfigurieren allgemeiner Feiertagskalender",
        GesetzlicheMindestloehneVerwaltung:
          "Gesetzliche Mindestlöhne Definieren",
        ZuschlagsrechnerVerwaltung: "Editieren von Zuschlagsrechnern",
          ImportMiloKonfig: "Import von Mindestlohn Konfigurationen",
          UeblicherLohnStammdatenAktualisieren: "Aktualisierung Stammdaten üblicher Lohn"
      },
      cmsDescriptions: {
        GavserviceContentmanager: "Zugriff auf CMS Gavservice",
        UniaContentmanager: "Zugriff auf CMS Uniaservice",
      },
    };
  },
  computed: {
    allRoleDescriptions() {
      return { ...this.rolesDescriptions, ...this.cmsDescriptions };
    },
  },
  created() {
    this.userId = this.$route.params.userId;
    this.LoadUser();
    this.GetRoles();
  },
  methods: {
    deleteUser() {
      DeleteUser(
        this.userId,
        () => {
          this.returnToOverview();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    returnToOverview() {
      this.$router.push({
        path: "/users",
      });
    },
    GetRoles() {
      GetRoles(
        (response) => {
          this.roles = this.SplitStringsArray(response, this.rolesDescriptions);
          this.cmsRoles = this.SplitStringsArray(
            response,
            this.cmsDescriptions,
          );
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    LoadUser() {
      this.errorObject = null;
      this.isLoading = true;

      GetUser(
        this.userId,
        (response) => {
          this.userObject = response;
          this.userObject.roles = this.SplitStringsArray(
            response.roles,
            this.allRoleDescriptions,
          );

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SaveUser() {
      this.errorObject = null;
      this.isLoading = true;
      const roles = [];

      this.userObject.roles.forEach((role) => {
        const roleSplit = role.split("[");
        roles.push(roleSplit[0].replace(/\s/g, ""));
      });

      this.userObject.roles = roles;

      UpdateUser(
        this.userId,
        this.userObject,
        () => {
          this.LoadUser();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SplitStringsArray(stringsArray = [], descriptions) {
      const strings = [];
      stringsArray.forEach((string) => {
        if (string in descriptions) {
          let roleDescription = descriptions[string];
          if (roleDescription) {
            strings.push(
              "".concat(
                string.replace(/[A-Z]/g, " $&").trim(),
                " [",
                roleDescription,
                "]",
              ),
            );
          }
        }
      });
      return strings;
    },
  },
};
</script>

<style>
.checkboxControl .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.checkboxControl .v-input--selection-controls__ripple:before {
  content: "\f14a";
  color: red;
  -webkit-animation: effect 250ms ease-in;
  animation: effect 250ms ease-in;
  font-weight: 900;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.contactsOverview {
  font-size: small;
  table-layout: fixed;
}

.userOverview thead th:nth-child(6) {
  width: 10%;
}

.userOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.userOverview td,
.userOverview th {
  padding: 8px 4px;
}
</style>
